import { cn } from "@/lib/utils";

interface Props {
    /** 0-100 */
    value: number;
    "aria-label": string;
    className?: string;
}

/**
 * The thin patient progress bar: form page progress and the forms count on the form-complete screen.
 * One component so both read as the same thing.
 */
const ProgressBar = ({ value, className, ...props }: Props) => {
    const percent = Math.max(0, Math.min(100, Math.round(value)));

    return (
        <div
            className={cn(
                "relative bg-slate-200 dark:bg-slate-800 rounded-full w-full h-1.5 overflow-hidden",
                className
            )}
            role="progressbar"
            aria-valuenow={percent}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={props["aria-label"]}
        >
            <div
                className="bg-indigo-600 dark:bg-indigo-400 rounded-full h-full transition-all duration-300"
                style={{ width: `${percent}%` }}
            />
        </div>
    );
};

export default ProgressBar;
